// @flow
const initialState = {
    phoneNumber:undefined,
    userId:undefined,
    isAuthenticated:false,
    otp:undefined,
    isLoading:false,
    validCheckHash:"",
    senderDetails:"",
    isShare:false,
    productDetail:{},
    surveyData:{},
    requestUrl:"",
};

export default function verify(state= initialState, action:any) {
    switch (action.type) {
        case 'GET_SENDER_DETAIL_PENDING':
            return {...state, isLoading: true, };

        case 'GET_SENDER_DETAIL_FULFILLED':
            return {...state,senderDetails:action.payload.data,isLoading:false};

        case 'GET_SENDER_DETAIL_REJECT':
        case 'GET_SENDER_DETAIL_REJECTED':
            return {...state,isLoading:false};
        case 'ADD_TO_CART_SHARE_PENDING':
            return {...state, isLoading: true, };

        case 'ADD_TO_CART_SHARE_FULFILLED':
            return {...state,requestUrl:action.payload.data.PaymentHash,isLoading:false};
        case 'SUBMIT_SURVEY_OPTION_PENDING':
            return {...state,  isLoading:true};
        case 'SUBMIT_SURVEY_OPTION_FULFILLED':
            return {...state, isLoading:false,requestUrl:action.payload.data.ValidatorKey};        
        case 'SUBMIT_SURVEY_OPTION_REJECT':
            return {...state, isLoading:false,};         
        case 'ADD_TO_CART_SHARE_REJECT':
                return {...state,isLoading:false};
        case 'VERIFY_PHONE_NUMBER_PENDING':
            return {...state, isAuthenticated: true,isLoading: true};

        case 'VERIFY_PHONE_NUMBER_FULFILLED':
            return {...state, isAuthenticated: false, phoneNumber:action.payload.data.Mobile,isLoading:false};

        case 'VERIFY_PHONE_NUMBER_REJECT':
            return {...state, isAuthenticated: false,isLoading:false};

        case 'VERIFY_OTP_PENDING':
            return {...state,isLoading:true };

        case 'VERIFY_OTP_FULFILLED':
            return {...state, isAuthenticated: true, 
                phoneNumber:action.payload.data.Mobile, 
                userId:action.payload.data.Key, 
                validCheckHash:action.payload.data.ValidCheckHash,
                isLoading:false
            };

        case 'VERIFY_OTP_REJECT':
            return {...state,isLoading:false};  

        case 'LOGIN_IS_SHARE':
            return {...state,isLoading:false,isShare:action.payload}; 

        case 'STORE_DETAIL_INFO':
            return {...state,isLoading:false,productDetail:action.payload}; 
        case 'STORE_SURVEY_DATA':
            return {...state,isLoading:false,surveyData:action.payload};         
        case 'LOG_OUT':
            return state;
            
        default:
            return state;
    }
}
